<template>
  <button class="Drop-Menu-Item" @click="toPin">
    <div class="Drop-Menu-Item__svg-box">
      <LoaderCircle :color="'var(--blue-600)'" :size="25" v-if="isLoading" />
      <PinIcon v-else/>
    </div>
    {{ get_btnTxt }}
  </button>
</template>

<script setup>
  import { ref, computed } from 'vue';
  import { useStore } from 'vuex';
  import { Props } from './scripts/props.js';
  //--------------------------------------------
  import PinIcon from '@svg/PinIcon.vue';
  import LoaderCircle from '@ui/Loaders/LoaderCircle/LoaderCircle.vue';
  //--------------------------------------------
  const store = useStore();
  const props = defineProps(Props());
  //--------------------------------------------
  const isLoading = ref(false);
  //--------------------------------------------
  //Получить текст кнопки
  const get_btnTxt = computed(() => props.signal.pinned ? 'Открепить' : 'Закрепить');
  //--------------------------------------------
  //Начать процесс закрепления / открепления сигнала
  const toPin = async() => {
    if(isLoading.value) return;
    try {
      toToggleLoading(true);
      await toPinSignal();
      store.dispatch('OverlayManagerSystem/addMessage', {text: 'Сигнал был закреплен', color: 'green'});
    } catch (error) {
      console.error('Ошибка при попытке открепить/прикрепить сигнал', error);
      store.dispatch('OverlayManagerSystem/addMessage', {text: 'Ошибка при попытке открепить/прикрепить сигнала', color: 'red'});
    } finally{
      toToggleLoading(false);
    }
  }
  //Убрать пост из списка
  const toPinSignal = async () => store.dispatch('Signals/pinSignal', { id: props.signal.id });
  //Переключить состояние процесса удаления поста
  const toToggleLoading = (status) => isLoading.value = status;
</script>

<style lang="scss">
  @import '../../../../styles/Drop-Menu-Item.scss';
</style>